export const MESSAGES_EN = {
  PROJECT_LIST_ORDER_MESSAGE: 'The most recent projects at the top',
  SKILLS_DATA_UPDATE_MESSAGE: 'All skills up-to-date.',
  CONSTANTLY_SKILLS_UPGRADING_MESSAGE:
    'Constantly upgrading my skill set to stay ahead in the ever-evolving tech landscape.',
};
